import { createFileRoute } from '@tanstack/react-router';

import {
    ScratchpadIndexPage,
    scratchpadSearchSchema,
} from '@apps/web/features/admin_agent_scratchpad';

export const Route = createFileRoute('/_app/admin/agent/scratchpad/')({
    component: ScratchpadIndexRoute,
    validateSearch: scratchpadSearchSchema,
    head: () => ({
        meta: [{ title: 'Agent Scratchpad | Phoebe Admin' }],
    }),
});

function ScratchpadIndexRoute() {
    const search = Route.useSearch();
    return <ScratchpadIndexPage search={search} />;
}
